import FullScreenModal from "./FullScreenModal";

export interface IFullScreenModalProps {
    children: React.ReactNode;
    CloseAriaLabel?: string;
    CloseTitle?: string;
    Header: string;
    ListenToBackgroundClick?: boolean;
    OnCloseRequest: () => void;
    RenderFooter?: () => JSX.Element;
    DisableClose?: boolean;
}

export { FullScreenModal };
